import { enumObject, EnumValue } from '@/utils';
import { TreeNodeDto } from '../http.communities';
import { TaskResponsiblePersonValue } from '../http.tasks';

const TYPE_VALUES = ['Default', 'Client'];
export type PathTemplateType = EnumValue<typeof TYPE_VALUES>;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PathTemplateType = enumObject('PathTemplateType', TYPE_VALUES);

export interface PathTemplateDto {
  id: string;
  name: string;
  type: PathTemplateType;
  organizationId: string;
  steps: PathTemplateStep[];
}

export interface UpdatePathTemplateDto {
  id: string;
  name: string;
  steps: PathTemplateStep[];
}

export type CreatePathTemplateDto = Omit<
  UpdatePathTemplateDto,
  'id' | 'steps'
> & {
  organizationId?: string;
  communityId?: string;
  steps: CreatePathTemplateStep[];
};

export interface PathTemplateStep {
  id: string;
  name: string;
  categories: string[];
  groupedTaskData: GroupedTasksDto | null;
}

export interface CreatePathTemplateStep {
  name: string;
  categories: string[];
  groupedTaskData: GroupedTasksDto | null;
}

export interface GroupedTasksDto {
  tasks: PathTemplateTaskDto[];
  groups: PathTemplateTaskGroupDto[];
}

export type PathTemplateTaskDto = {
  name: string;
  responsiblePerson?: TaskResponsiblePersonValue;
  costEstimate?: number;
  groupId: string | null;
};

export interface PathTemplateTaskGroupDto {
  id: string;
  name: string;
}

export type PathTemplateDetailsDto = Omit<PathTemplateDto, 'steps'> & {
  steps: PathTemplateStepDetailsDto[];
  communityId?: string;
  communityName?: string;
};

export interface PathTemplateStepDetailsDto {
  index?: number;
  name: string;
  selectedCategories: TreeNodeDto[];
  groupedTaskData: GroupedTasksDto | null;
}
